var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.authStatus === '' || _vm.authStatus === 'SIGN_IN' || _vm.authStatus === 'SIGNED_IN' || _vm.authStatus == undefined)?_c('SignInFlow',{on:{"signed-in":function($event){return _vm.closeAuthenticator()}}}):(_vm.authStatus === 'SIGN_UP')?_c('SignUpFlow'):(_vm.authStatus === 'FORGOT_PASSWORD')?_c('ForgotPasswordFlow'):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }